// extracted by mini-css-extract-plugin
export default {"container":"ItemList_container__xUjd8"};